/**
 * Numérotation officielle des documents d'État.
 *
 * Ces codes sont partagés parce que la PWA Verify les affiche et les contrôle
 * hors ligne : ils ne peuvent pas rester enfermés côté serveur. Le calcul du
 * caractère de contrôle, lui, vit dans `@sygap/core`.
 *
 * Format : `TYPE-AAAA-GN-NNNNN-C`, cf. spécification de sécurité des documents
 * officiels v1.0 §4.1.
 */
import { valeurs } from './enumeration.js';
/** Préfixes de type dans le numéro officiel. */
export const TYPE_NUMERO_OFFICIEL = {
    /** Licence de pêche industrielle — `LICENCE.numero_officiel`. */
    LICENCE: 'LIC',
    /** Permis de pêche artisanale — `PERMIS.numero_officiel`. */
    PERMIS: 'PRM',
    /** Avis de paiement — `AVIS_PAIEMENT.numero_avis`. */
    AVIS_PAIEMENT: 'AVP',
    /** Demande — `DEMANDE.reference_demande`. */
    DEMANDE: 'DEM',
    /** Ticket d'assistance — `TICKET.numero_ticket`. */
    TICKET: 'TCK',
    /** Agrément sanitaire — `DOCUMENT_DELIVRE.numero_officiel`. */
    AGREMENT: 'AGR',
    /** Fiche de visite technique — `DOCUMENT_DELIVRE.numero_officiel`. */
    VISITE: 'VIS',
    /** Attestation (retrait de journal, INN…) — `DOCUMENT_DELIVRE.numero_officiel`. */
    ATTESTATION: 'ATT',
};
export const TYPES_NUMERO_OFFICIEL = valeurs(TYPE_NUMERO_OFFICIEL);
/** Indicatif pays inséré dans le numéro officiel (République de Guinée). */
export const INDICATIF_PAYS = 'GN';
/** Nombre de chiffres du compteur séquentiel (`NNNNN`). */
export const LONGUEUR_SEQUENCE = 5;
/** Bornes du compteur séquentiel imposées par le format à 5 chiffres. */
export const SEQUENCE_MIN = 1;
export const SEQUENCE_MAX = 99_999;
/** Alphabet du caractère de contrôle : 26 lettres majuscules, sans chiffre. */
export const ALPHABET_CONTROLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
//# sourceMappingURL=numerotation.js.map